// src/components/LatexBlock.jsx
import Latex from "react-latex-next";
import "katex/dist/katex.min.css";     // obliga a CRA a incluir el CSS

export default function LatexBlock({ children }) {
  /* Si tu BD trae <br>, conviértelo a \n antes de pasarlo, 
     o haz el replace aquí si quieres: 
       const text = String(children).replace(/<br\s*\/?>/gi, "\n");
       return <Latex>{text}</Latex>;
  */
  return <Latex>{children}</Latex>;
}
